import React from 'react';
import { PageDataProvider } from '../PageDataContext';

export interface RegionDataProviderProps {
  children: React.ReactNode;
  /** Region slug (e.g. 'new-england') - determines which data to provide */
  regionSlug?: string;
}

/** Static fishery stats for new-england region. Other regions get empty data. */
const NEW_ENGLAND_FISHERY_DATA = {
  year: '2022',
  landedExVesselValue: 1400000000,
  missedRevenueToFishermen: 2761000000,
  landedEconomicImpact: 5359000000,
  jobs: 290000,
  landedMeals: 839500000,
  fishingExpenditure: 584000000,
};

function fisheryStatsToInsights(stats: Record<string, unknown> | null): Record<string, unknown> | null {
  if (!stats) return null;
  return {
    exVesselValue: stats.landedExVesselValue,
    missedValue: stats.missedRevenueToFishermen,
    economyValue: stats.landedEconomicImpact,
    totalJobs: stats.jobs,
    mealsProduced: stats.landedMeals,
  };
}

export function RegionDataProvider({ children, regionSlug }: RegionDataProviderProps): React.ReactElement {
  const effectiveSlug = regionSlug || 'new-england';
  const fisheryStats = effectiveSlug === 'new-england' ? NEW_ENGLAND_FISHERY_DATA : null;
  const insights = fisheryStatsToInsights(fisheryStats as Record<string, unknown> | null);
  const data =
    effectiveSlug === 'new-england'
      ? {
          fisheryStats: NEW_ENGLAND_FISHERY_DATA,
          insights,
          originalInsights: insights,
        }
      : { fisheryStats: null, insights: null, originalInsights: null };

  const value = {
    data,
    loading: false,
    error: null,
    actions: {} as Record<string, (...args: unknown[]) => void | Promise<void>>,
  };

  return <PageDataProvider value={value}>{children}</PageDataProvider>;
}
